"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var config_1 = require("../config");

var Icon_1 = __importStar(require("../Icon"));

var Search =
/** @class */
function (_super) {
  __extends(Search, _super);

  function Search(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (e) {
      var value = e.currentTarget.value;

      _this.setState({
        value: value
      });
    };

    _this.onClick = function () {
      _this.props.onSelected(_this.state.value);
    };

    _this.onKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.onClick();
      }
    };

    _this.state = {
      value: props.value,
      prevPropsValue: props.value
    };
    return _this;
  }

  Search.getDerivedStateFromProps = function (props, state) {
    if (props.value !== state.value && state.prevPropsValue !== props.value) {
      return {
        value: props.value,
        prevPropsValue: props.value
      };
    }

    return null;
  };

  Search.prototype.render = function () {
    var value = this.state.value;
    return react_1.default.createElement("div", {
      className: config_1.UIKIT + "__input__container"
    }, react_1.default.createElement("input", {
      type: "text",
      value: value,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      className: config_1.UIKIT + "__input " + config_1.UIKIT + "__input--with_stop_icon"
    }), react_1.default.createElement(Icon_1.default, {
      icon: Icon_1.IconType.Search,
      className: "icon_stop",
      onClick: this.onClick
    }));
  };

  return Search;
}(react_1.default.Component);

exports.default = Search;